import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "customFieldsContainer"];
  static values = {
    integrationId: Number,
    fieldNamePrefix: String,
    existingValues: Object,
  };

  selectTargetConnected(element) {
    const hiddenInput = element.querySelector('input[type="hidden"]');
    if (hiddenInput?.value) {
      this.loadCustomFields(hiddenInput.value);
    }
  }

  onFormChange(event) {
    this.loadCustomFields(event.target.value);
  }

  loadCustomFields(formId) {
    if (!formId || !this.integrationIdValue) {
      this.clearCustomFields();
      return;
    }

    if (!this.hasCustomFieldsContainerTarget) return;

    this.customFieldsContainerTarget.innerHTML =
      '<div class="mt-4 text-sm text-gray-600">Loading fields...</div>';

    let url = `/admin/zendesk_ticketing_integrations/${this.integrationIdValue}/available_custom_fields?form_id=${formId}&field_name_prefix=${encodeURIComponent(this.fieldNamePrefixValue)}`;

    if (this.existingValuesValue && Object.keys(this.existingValuesValue).length > 0) {
      url += `&existing_values=${encodeURIComponent(JSON.stringify(this.existingValuesValue))}`;
    }

    this.customFieldsContainerTarget.src = url;
  }

  clearCustomFields() {
    if (!this.hasCustomFieldsContainerTarget) return;

    this.customFieldsContainerTarget.innerHTML =
      '<div class="mt-4 text-sm text-gray-600">Select a ticket form to configure custom fields</div>';
  }

  setIntegrationId(id) {
    this.integrationIdValue = id;
  }
}
